var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import introJs from 'intro.js';
import { writeDB, readDB } from './utils';
import data from './data.json';
let intro = null;
let cacheHintsMap = {};
export const startHint = (active) => __awaiter(void 0, void 0, void 0, function* () {
    if (intro) {
        const currentHints = getCurrentHints(active);
        intro.setOptions({
            hints: formatHints(currentHints),
        });
        intro === null || intro === void 0 ? void 0 : intro.addHints();
        return;
    }
    cacheHintsMap = (yield getHintsCache()) || {};
    intro = generatorIntro(active);
    return;
});
const getHintsCache = () => __awaiter(void 0, void 0, void 0, function* () { return yield readDB('tab-intro-userguild'); });
const generatorIntro = (active) => {
    const currentHints = getCurrentHints(active);
    if (currentHints.length <= 0) {
        return null;
    }
    const intro = introJs('#app');
    intro.setOptions({
        hintButtonLabel: '知道了',
        hints: formatHints(currentHints),
    });
    intro.addHints();
    intro.onhintclose((stepId) => {
        const target = currentHints[stepId];
        markHintReaded(target);
    });
    return intro;
};
const markHintReaded = (target) => {
    const key = spliceKey(target.active, target.source);
    cacheHintsMap[key] = target.version;
    writeDB('tab-intro-userguild', cacheHintsMap);
};
const getCurrentHints = (currentActive) => {
    const { hints } = data;
    return hints.filter((item) => {
        const { active, version, source } = item;
        const hintKey = spliceKey(active, source);
        const hintVersion = cacheHintsMap[hintKey] || -1;
        return (active === currentActive || item.active === 'global')
            && version > hintVersion;
    });
};
const spliceKey = (active, source) => `${active}:${source}`;
const formatHints = (hints) => hints.map(item => ({
    element: item.element,
    hint: getHint(item),
    position: item.position,
}));
const getHint = (hint) => {
    let html = '<div class="tab-intro-hint-container">';
    if (hint.img) {
        html += `<img src="${hint.img}" />`;
    }
    html += `<div class="tab-intro-hint-desc">${hint.text}</div></div>`;
    if (hint.link) {
        html += `<a class="info-link" href="${hint.link}"" target="_blank">了解更多</>`;
    }
    return html;
};
export const removeHints = () => intro === null || intro === void 0 ? void 0 : intro.removeHints();
export const refresh = () => intro === null || intro === void 0 ? void 0 : intro.refresh();
